var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-4 rounded",attrs:{"height":"36px","width":"36px","outlined":"","tile":"","icon":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',{attrs:{"size":"24"}},[_vm._v(" mdi-arrow-left ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }